import { gql } from "apollo-boost";

export const dashboardQuery = gql`
  query Dashboard($account: String!) {
    user(id: $account) {
      stake(first: 1000, where: { altQuantity_gt: 0 }) {
        id
        altQuantity
        durationTimestamp
        initiationTimestamp
      }
      history(first: 1000, orderBy: id, orderDirection: desc) {
        id
        altQuantity
        rewardAmount
        durationTimestamp
        initiationTimestamp
      }
    }
  }
`;
// console.log("Graph data dashboardQuery", dashboardQuery);
